<template>
  <div class="inside_container">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <section class="top_banner">
      <div class="middle_content img_default" :style="getBackgrounUrl(currentArea.banner_img)">
        <p class="left_p">プランお申し込みページ</p>
        <div>
          <h3>{{currentArea.title}}</h3>
          <p class="sub_title">- {{currentArea.name}} -</p>
        </div>
      </div>
    </section>
    <section class="area_content">
      <div class="choosed_area clearfix">
        <p class="left_p">選択中のプラン</p>
        <p class="area_title" v-if="!isChina">“ {{currentCountry.title}} ” プラン</p>
        <p class="area_title" v-if="isVPN">“ {{currentCountry.title}}プレミアム ” プラン</p>
        <p class="area_title" v-if="isChina && !isVPN">“ {{currentCountry.title}}通常 ” プラン</p>
      </div>
      <h3 class="top_title">
        <span class="img_default">1日の高速通信容量を選択する</span>
      </h3>
      <!-- <div class="sub_title_content" v-if="filteredSingle.length>0">
        <h4>
          <span>単国プラン</span>
        </h4>
        <p>１カ国しか行く予定がない場合は「単国プラン」！</p>
      </div> -->
      <ul class="capacity_content">
        <li
          class="main_unlimited"
          v-for="(product, index) in filteredSingle"
          :key="index"
          :class="getProductClass(product.description)"
        >
          <a :href="product.url">
            <div class="labels clearfix" v-if="product.recommend">
              <p class="star img_default">オススメ</p>
            </div>
            <p class="capacity_img img_default" :class="getCapacityClass(product.capacityIcon)">
              <span class="top_sub_title">{{product.description}}</span>
              <span class="main_title">“ {{product.name}} ”</span>
            </p>
            <p class="price">{{product.unitPrice}}{{product.unit}}</p>
          </a>
        </li>
      </ul>

      <!-- <div class="sub_title_content" v-if="filteredMultiple.length>0">
        <h4>
          <span>周遊プラン</span>
        </h4>
        <p>
          「周遊プラン」は通信容量の選択が可能！
          <br />容量抑えて、低価格ご希望の方はこちらがオススメ
        </p>
      </div> -->
      <ul class="capacity_content">
        <li
          v-for="(product, index) in filteredMultiple"
          :key="index"
          :class="getProductClass(product.description)"
        >
          <a :href="product.url">
            <div class="labels clearfix" v-if="product.recommend">
              <p class="star img_default">オススメ</p>
            </div>
            <!--<p class="capacity_img capacity_01 img_default">-->
            <p class="capacity_img img_default" :class="getCapacityClass(product.capacityIcon)">
              <span class="top_sub_title">{{product.description}}</span>
              <span class="main_title">“ {{product.name}} ”</span>
            </p>
            <p class="price">{{product.unitPrice}}{{product.unit}}</p>
          </a>
        </li>
      </ul>

      <ul class="note" v-if="isVPN">
        <li>
          <p>※「中国プレミアム」プランは、”500MB”のみのご提供となっております。</p>
        </li>
      </ul>
      <div class="sub_title_content data_flow">
        <h4>
          <span class="img_default">データ通信量の目安</span>
        </h4>
        <p>
          プラン選択の参考にご活用ください
          <br />
          <span>※周遊プランを選択の方のみ、通信容量をお選びいただけます</span>
        </p>
      </div>
      <div class="tab_capacity">
        <ul class="tab_title clearfix">
          <li class="btn_01" @click="currentTab=0" :class="{'active':currentTab===0 }">
            <a>
              <p class="img_default">350MBプラン</p>
            </a>
          </li>
          <li class="btn_02" @click="currentTab=1" :class="{'active':currentTab===1 }">
            <a>
              <p class="img_default">500MBプラン</p>
            </a>
          </li>
          <li class="btn_03" @click="currentTab=2" :class="{'active':currentTab===2 }">
            <a>
              <p class="img_default">1GBプラン</p>
            </a>
          </li>
        </ul>
        <div id="tab01" v-if="currentTab===0" class="tab_inner">
          <ul class="note">
            <li>
              <img src="images/safari_icon.png" />
              <p class="app_title">Webサイト</p>
              <p class="ex">Google検索/1回</p>
              <p class="return">約1,500回</p>
            </li>
            <li>
              <p class="top">目的地検索</p>
              <img src="images/googlemap_icon.png" />
              <p class="app_title">Googleマップ</p>
              <p class="ex">/1回 (3MB程度)</p>
              <p class="return">約60回</p>
            </li>
            <li>
              <img src="images/gmail_icon.png" />
              <p class="app_title">メール送受信</p>
              <p class="ex">100文字/１通</p>
              <p class="return">約3,500通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">テキストトーク</p>
              <p class="return">約3,000通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">音声通話</p>
              <p class="return">約5時間</p>
            </li>
            <li>
              <img src="images/twitter_icon.png" />
              <p class="app_title">Twitter</p>
              <p class="ex">ツイート</p>
              <p class="return">約300回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">写真投稿/1回 (約1.5MB)</p>
              <p class="return">約200回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">閲覧利用</p>
              <p class="return">約20分</p>
            </li>
            <li>
              <img src="images/youtube_icon.png" />
              <p class="app_title">YouTube</p>
              <p class="ex">標準画質480p</p>
              <p class="return">約40分</p>
            </li>
          </ul>
        </div>
        <div id="tab02" v-if="currentTab===1" class="tab_inner">
          <ul class="note">
            <li>
              <img src="images/safari_icon.png" />
              <p class="app_title">Webサイト</p>
              <p class="ex">Google検索/1回</p>
              <p class="return">約2,500回</p>
            </li>
            <li>
              <p class="top">目的地検索</p>
              <img src="images/googlemap_icon.png" />
              <p class="app_title">Googleマップ</p>
              <p class="ex">/1回 (3MB程度)</p>
              <p class="return">約100回</p>
            </li>
            <li>
              <img src="images/gmail_icon.png" />
              <p class="app_title">メール送受信</p>
              <p class="ex">100文字/１通</p>
              <p class="return">約5,000通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">テキストトーク</p>
              <p class="return">約5,000通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">音声通話</p>
              <p class="return">約7時間</p>
            </li>
            <li>
              <img src="images/twitter_icon.png" />
              <p class="app_title">Twitter</p>
              <p class="ex">ツイート</p>
              <p class="return">約500回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">写真投稿/1回 (約1.5MB)</p>
              <p class="return">約300回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">閲覧利用</p>
              <p class="return">約30分</p>
            </li>
            <li>
              <img src="images/youtube_icon.png" />
              <p class="app_title">YouTube</p>
              <p class="ex">標準画質480p</p>
              <p class="return">約60分</p>
            </li>
          </ul>
        </div>
        <div id="tab03" v-if="currentTab===2" class="tab_inner">
          <ul class="note">
            <li>
              <img src="images/safari_icon.png" />
              <p class="app_title">Webサイト</p>
              <p class="ex">Google検索/1回</p>
              <p class="return">約5,000回</p>
            </li>
            <li>
              <p class="top">目的地検索</p>
              <img src="images/googlemap_icon.png" />
              <p class="app_title">Googleマップ</p>
              <p class="ex">/1回 (3MB程度)</p>
              <p class="return">約200回</p>
            </li>
            <li>
              <img src="images/gmail_icon.png" />
              <p class="app_title">メール送受信</p>
              <p class="ex">100文字/１通</p>
              <p class="return">約10,000通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">テキストトーク</p>
              <p class="return">約10,000通</p>
            </li>
            <li>
              <img src="images/line_icon.png" />
              <p class="app_title">LINE</p>
              <p class="ex">音声通話</p>
              <p class="return">約14時間</p>
            </li>
            <li>
              <img src="images/twitter_icon.png" />
              <p class="app_title">Twitter</p>
              <p class="ex">ツイート</p>
              <p class="return">約1,000回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">写真投稿/1回 (約1.5MB)</p>
              <p class="return">約600回</p>
            </li>
            <li>
              <img src="images/insta_icon.png" />
              <p class="app_title">Instagram</p>
              <p class="ex">閲覧利用</p>
              <p class="return">約60分</p>
            </li>
            <li>
              <img src="images/youtube_icon.png" />
              <p class="app_title">YouTube</p>
              <p class="ex">標準画質480p</p>
              <p class="return">約120分</p>
            </li>
          </ul>
        </div>
      </div>
      <ul class="note">
        <li>
          <p>※各数値はあくまで一般的な利用を想定した目安です。</p>
        </li>
        <li>
          <p>※Googleマップは目的地検索の目安であり、ルート検索の際には上記目安を超えるデータ通信を要する場合が御座います。通信料超過にご注意ください。</p>
        </li>
        <li>
          <p>※対応機種、設定によって異なる場合が御座います。</p>
        </li>
        <li>
          <p>※インターネット接続環境によってデータ量が変動する場合が御座います。</p>
        </li>
        <li>
          <p>※アプリの動作を保証するものでは御座いません。予めご了承ください。</p>
        </li>
      </ul>
    </section>
    <!--
    <section class="plan_content">
      <h3 class="top_title">{{$t("Select A Product")}}</h3>
      <ul class="plan_list_row clearfix">
        <li v-for="(product, index) in products" :key="index">
          <div class="plan_info clearfix">
            <div class="left_content clearfix">
              <h4 class="plan_title">{{product.name}}</h4>
              <p class="plan_price">
                <span>
                  <span class="p_s">{{product.currency}}</span>
                  {{product.unitPrice}}
                </span>
                /{{$t(product.unit)}}
              </p>
            </div>
            <p class="plan_order">
              <a :href="product.url">{{$t("Order Now")}}</a>
            </p>
          </div>
        </li>
      </ul>
    </section>
    -->
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

export default {
  name: "JetfiProducts",
  props: {},
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      baseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
      planUrl: process.env.VUE_APP_PLAN_API,
      bid: process.env.VUE_APP_PLAN_BID,
      isLoading: false,
      fullPage: true,
      products: [],
      currentCountryId: null,
      currentCountry: {},
      currentPageCode: null,
      //currentCountry: null,
      isCountriesLoaded: false,
      isProductssLoaded: false,
      currentArea: {},
      getAreaErrorMessage: "",
      isAreaLoaded: false,
      selectedAreaId: null,
      currentTab: 0
    };
  },
  created: function() {
    console.log(this.$store.state.isAreasLoaded);
    this.selectedAreaId = this.$router.currentRoute.query.aid ||
      Vue.$sessionStorage.get("currentArea") || this.$store.state.currentArea;

    this.initialize();
  },
  mounted: function() {},
  methods: {
    initialize() {
      console.log("[JetfiProducts] initialize");
      this.isLoading = true;
      this.getAreaById();

      this.currentCountryId = this.$router.currentRoute.query.cid ||
        Vue.$sessionStorage.get("currentCountry") ||
        this.$store.state.currentCountry;
      //this.currentCountryName = Vue.$sessionStorage.get("currentCountryName");
      this.currentPageCode = this.$router.currentRoute.query.pcode ||
        Vue.$sessionStorage.get("currentPageCode") ||
        this.$store.state.currentPageCode;

      if (!this.currentCountryId) {
        let params = Object.assign({}, this.$router.currentRoute.query); 
        delete params['cid'];
        delete params['pcode'];
        this.$router.push({
          path: "countries",
          query: params
        });
      } else {
        //this.currentCountryId = Vue.$sessionStorage.get("currentCountry") || this.$store.state.currentCountry;
        //this.currentPageCode = Vue.$sessionStorage.get("currentPageCode") || this.$store.state.currentPageCode;
        this.getCountryById();
        // this.getPlans();
      }
    },
    getBackgrounUrl(img) {
      // console.log(area.img_src)
      // let imageUrl = "images/" + area.img_src;
      if (img) {
        let imageUrl = encodeURI(this.baseImageUrl + "/" + img);
        //console.log(imageUrl);
        return {
          "background-image": `url(${imageUrl})`
        };
      } else {
        return {};
      }
    },
    getProductClass(description) {
      var classObj = {
        no_subtitle: true
      };

      if (description && description.length) {
        classObj["no_subtitle"] = false;
      }

      return classObj;
    },
    getCapacityClass(capacityClass) {
      var capacityObj = {};

      if (capacityClass) {
        capacityObj[capacityClass] = true;
      }

      return capacityObj;
    },
    getAreaById() {
      console.log("[JetfiProducts] get area by id");
      this.$store
        .dispatch("getAreaById", {
          params: {
            aid: this.selectedAreaId,
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log("[JetfiProducts] store area:", this.$store.state.area);
          this.isAreaLoaded = this.$store.state.isAreaLoaded;
          this.errorMessage = this.$store.state.getAreaErrorMessage;
          this.currentArea = this.$store.state.area;
        });
    },
    getCountryById() {
      console.log("[JetfiProducts] get country by id");
      this.$store
        .dispatch("getCountryById", {
          params: {
            cid: this.currentCountryId,
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log(
            "[JetfiProducts] store country:",
            this.$store.state.country
          );
          this.isCountryLoaded = this.$store.state.isCountryLoaded;
          this.errorMessage = this.$store.state.getCountryErrorMessage;
          this.currentCountry = this.$store.state.country;
        })
        .finally(() => {
          this.getPlans();
        });
    },
    getPlans() {
      console.log("[JetfiProducts] get plans");

      axios
        .get(
          this.planUrl,
          {
            params: {
              //page_code: this.currentCountry.length ? this.currentCountry[0].page_code : null,
              page_code: this.currentPageCode,
              business_id: this.bid,
              country_name: this.currentCountry ? this.currentCountry.name : null,
              country_title: this.currentCountry ? this.currentCountry.title : null,
              distributorCode: this.$router.currentRoute.query.d,
              couponCode: this.$router.currentRoute.query.c
            }
          },
          {
            withCredentials: true //allow cookie
          }
        )
        .then(response => {
          console.log("[JetfiProducts] get plans done", response.data);
          this.products = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log("[JetfiProducts] get plans failed", error.response);
          console.log(error);
          this.isLoading = false;
          this.products = [];
        });
    }
  },
  computed: {
    filteredSingle: function() {
      return this.products
        ? this.products.filter(function(product) {
            return product.planType === "single";
          })
        : this.products;
    },
    filteredMultiple: function() {
      return this.products
        ? this.products.filter(function(product) {
            return product.planType === "multiple";
          })
        : this.products;
    },
    isChina: function() {
      var self = this;
      return self.currentCountry && self.currentCountry.name && self.currentCountry.name.toUpperCase() === "CHINA";
    },
    isVPN: function() {
      var self = this;
      return (
        self.isChina && self.currentCountry.sns_code === self.currentPageCode
      );
    }
  },
  components: {
    Loading
  }
};
</script>